import React from "react";
import Layout from "../components/layout/Layout";
import { Card } from "antd";
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
  RadialBar,
  RadialBarChart,
} from "recharts";
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend as ChartLegend,
} from "chart.js";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  ArcElement,
  ChartTooltip,
  ChartLegend
);

const radialBarData = [
  { name: "OEE", value: 25, fill: "#0071BC" },
  { name: "Kullanılabilirlik", value: 92, fill: "#0071BC" },
  { name: "Performans", value: 87, fill: "#0071BC" },
  { name: "Kalite", value: 95, fill: "#0071BC" },
];

const dummyMachineData = [
  { name: "Çalışan Makineler", value: 60 },
  { name: "Duran Makineler", value: 25 },
  { name: "Bakımdaki Makineler", value: 15 },
];

const radarData = {
  labels: ["D1", "D2", "D3", "D4", "D5", "D6", "D7"],
  datasets: [
    {
      label: "OEE",
      data: [80, 70, 50, 30, 40, 60, 75], // Dummy Data
      backgroundColor: "rgba(0, 113, 188, 0.3)", // Açık mavi (şeffaf)
      borderColor: "#0071BC", // Koyu mavi
      borderWidth: 2,
    },
  ],
};

const radarOptions = {
  scales: {
    r: {
      beginAtZero: true,
      min: 0,
      max: 100,
      ticks: { stepSize: 20 },
      grid: { color: "rgba(0,0,0,0.1)" },
    },
  },
  plugins: {
    legend: { display: false },
  },
};

const lastTenDaysData = [
  { date: "2024-01-01", planned: 100, produced: 90 },
  { date: "2024-01-02", planned: 110, produced: 100 },
  { date: "2024-01-03", planned: 120, produced: 124 },
  { date: "2024-01-04", planned: 115, produced: 100 },
  { date: "2024-01-05", planned: 106, produced: 107 },
  { date: "2024-01-06", planned: 111, produced: 109 },
  { date: "2024-01-07", planned: 110, produced: 103 },
  { date: "2024-01-08", planned: 118, produced: 119 },
  { date: "2024-01-09", planned: 115, produced: 107 },
  { date: "2024-01-11", planned: 104, produced: 98 },
  { date: "2024-01-12", planned: 104, produced: 98 },
  { date: "2024-01-13", planned: 85, produced: 98 },
  { date: "2024-01-14", planned: 32, produced: 98 },
  { date: "2024-01-15", planned: 57, produced: 98 },
  { date: "2024-01-15", planned: 100, produced: 98 },
  { date: "2024-01-16", planned: 78, produced: 98 },
  { date: "2024-01-17", planned: 85, produced: 98 },
  { date: "2024-01-18", planned: 79, produced: 98 },
  { date: "2024-01-19", planned: 94, produced: 98 },
  { date: "2024-01-20", planned: 89, produced: 98 },
];

const dummyDepartmentData = [
  { name: "Departman 1", active: 10, inactive: 5, maintenance: 2 },
  { name: "Departman 2", active: 15, inactive: 3, maintenance: 4 },
  { name: "Departman 3", active: 8, inactive: 6, maintenance: 5 },
  { name: "Departman 4", active: 12, inactive: 4, maintenance: 3 },
  { name: "Departman 5", active: 14, inactive: 2, maintenance: 6 },
  { name: "Departman 6", active: 9, inactive: 7, maintenance: 3 },
  { name: "Departman 7", active: 11, inactive: 5, maintenance: 2 },
];

const COLORS = ["#05588C", "#0071BC", "#B5D7F3"];

const MonitoringPage = () => {
  return (
    <Layout>
      <div className="pt-16 ml-64 p-4">
        <div className="grid grid-cols-4 gap-4 mb-8 mt-4">
          {/* Left Cards */}
          <div className="flex flex-col gap-4 lg:grid-cols-2">
            {radialBarData.map((item, index) => (
              <Card
                key={index}
                className="flex flex-col justify-center items-center"
              >
                <h3 className="text-sm font-semibold text-gray-700">
                  {item.name}
                </h3>
                <RadialBarChart
                  width={120}
                  height={120}
                  innerRadius="70%"
                  outerRadius="100%"
                  startAngle={180}
                  endAngle={180 - (item.value / 100) * 180}
                  data={[item]}
                >
                  <RadialBar
                    minAngle={15}
                    clockWise
                    dataKey="value"
                    fill="#0071BC"
                    background={{ fill: "#B5D7F3" }}
                  />
                </RadialBarChart>
                <div className="text-center text-2xl font-bold text-blue-600">
                  %{item.value}
                </div>
              </Card>
            ))}
          </div>
          {/* Right Side Charts */}
          <div className="flex flex-col col-span-3 gap-4">
            {/* OEE Chart */}
            <div className="flex justify-start items-center h-full bg-white rounded-lg shadow-md p-4 border border-gray-200">
              <h3 className="text-lg font-semibold text-gray-700 mb-4 text-center">
                OEE
              </h3>
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  data={lastTenDaysData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Line
                    type="monotone"
                    dataKey="planned"
                    stroke="#0071BC"
                    name="OEE"
                    strokeWidth={2}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
            {/* Departments Chart */}
            <div className="flex justify-start items-center h-full bg-white rounded-lg shadow-md p-4 border border-gray-200">
              <BarChart
                width={700}
                height={300}
                data={dummyDepartmentData}
                className="items-center"
              >
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="active" fill="#05588C" name="Çalışan Makineler" />
                <Bar dataKey="inactive" fill="#0071BC" name="Duran Makineler" />
                <Bar
                  dataKey="maintenance"
                  fill="#B5D7F3"
                  name="Bakımdaki Makineler"
                />
              </BarChart>
            </div>
          </div>
        </div>

        {/* Machine Status Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-8">
          {/* Donut Chart (Sol Taraf) */}
          <div className="bg-white rounded-lg shadow-md p-4 border border-gray-200 flex flex-col justify-center items-center lg:col-span-1 h-[400px]">
            <h3 className="text-center text-lg font-semibold text-gray-900 mb-4">
              Makine Durumu
            </h3>
            <PieChart width={475} height={300}>
              <Pie
                data={dummyMachineData}
                dataKey="value"
                cx="40%"
                cy="50%"
                innerRadius={80}
                outerRadius={120}
                fill="#82ca9d"
                label
              >
                {dummyMachineData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Legend layout="vertical" align="right" verticalAlign="middle" />
            </PieChart>
          </div>

          {/* Radar Chart */}
          <div className="bg-white rounded-lg shadow-md p-8 border border-gray-200 flex flex-col justify-center items-center lg:col-span-1 h-[400px]">
            <h3 className="text-center text-lg font-semibold text-gray-900 mb-4">
              Departman OEE
            </h3>
            <Radar data={radarData} options={radarOptions} />
          </div>
        </div>

        {/* OEE Chart */}
        <div className="bg-white rounded-lg shadow-md p-4 border border-gray-200 mb-8">
          <h3 className="text-lg font-semibold text-gray-700 mb-4 text-center">
            OEE
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart
              data={lastTenDaysData}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line
                type="monotone"
                dataKey="planned"
                stroke="#0071BC"
                name="OEE"
                strokeWidth={2}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Departments Chart & Best/Worst Departments */}
        <div className="grid grid-cols-3 gap-4">
          <div className="flex justify-start items-center h-full col-span-2 bg-white rounded-lg shadow-md p-4 border border-gray-200">
            <BarChart
              width={700}
              height={300}
              data={dummyDepartmentData}
              className="items-center"
            >
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="active" fill="#05588C" name="Çalışan Makineler" />
              <Bar dataKey="inactive" fill="#0071BC" name="Duran Makineler" />
              <Bar
                dataKey="maintenance"
                fill="#B5D7F3"
                name="Bakımdaki Makineler"
              />
            </BarChart>
          </div>

          <div className="flex flex-col gap-2 lg:grid-cols-2">
            <div className="bg-white rounded-lg shadow-md p-4 border border-gray-200 flex flex-col h-[195px]">
              <div className="flex-1 flex items-center justify-center">
                <div className="text-2xl font-bold text-gray-900">
                  En İyi Departman
                </div>
              </div>
              <hr className="border-gray-300 w-full" />
              <div className="flex-1 flex items-center justify-center">
                <div className="text-xl font-bold text-gray-900">
                  Üretim Departmanı
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md p-4 border border-gray-200 flex flex-col h-[195px]">
              <div className="flex-1 flex items-center justify-center">
                <div className="text-2xl font-bold text-gray-900">
                  En Kötü Departman
                </div>
              </div>
              <hr className="my-2 border-gray-300 w-full" />
              <div className="flex-1 flex items-center justify-center">
                <div className="text-center text-xl font-bold text-gray-900">
                  Kalite Kontrol Departmanı
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MonitoringPage;
